import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const GenerateProviderChecklistOverviewReport =
  (apiData) => async (dispatch) => {
    try {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
      const response = await axios({
        method: "get", // Change GET to POST
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/provider/SpecificProviderChecklistOverviewReport`,
        params: {
          ...apiData,
          // status: apiData.status.replace(/\s+/g, "_"),
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id)
          ),
          provider_org_ids: JSON.stringify(apiData.provider_org_ids),
          checklist_ids: JSON.stringify(apiData.checklist_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

export const GenerateProviderInvoiceReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "get", // Change GET to POST
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/SpecificProviderInvoiceReport`,
      params: {
        ...apiData,

        provider_org_ids: JSON.stringify(apiData.provider_org_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const GenerateProviderWorkersDocsReport =
  (apiData) => async (dispatch) => {
    try {
      const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
      const response = await axios({
        method: "get", // Change GET to POST
        headers: {
          Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
          "Content-Type": "application/json",
          organisationid: storedData?.organisation_id,
        },
        url: `${actionType.environment_url}/api/provider/SpecificProviderWorkersDocsReport`,
        params: {
          ...apiData,
          // status: apiData.status.replace(/\s+/g, "_"),
          client_org_ids: JSON.stringify(
            apiData.client_org_ids?.map((item) => item?.organisation_id)
          ),
          provider_org_ids: JSON.stringify(apiData.provider_org_ids),
          worker_ids: JSON.stringify(apiData.worker_ids),
          document_ids: JSON.stringify(apiData.document_ids),
        },
      });

      return response.data;
    } catch (error) {
      return error.message;
    }
  };

export const TriggerProviderChecklistReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/TriggerProviderChecklistReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify(
          apiData.client_org_ids?.map((item) => item?.organisation_id)
        ),
        provider_org_ids: JSON.stringify(apiData.provider_org_ids),
        checklist_ids: JSON.stringify(apiData.checklist_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerProviderInvoiceReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/TriggerProviderInvoiceReport`,
      data: {
        ...apiData,
        provider_org_ids: JSON.stringify(apiData.provider_org_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const TriggerProviderWorkerDocsReport = (apiData) => async (dispatch) => {
  try {
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
        "Content-Type": "application/json",
        organisationid: storedData?.organisation_id,
      },
      url: `${actionType.environment_url}/api/provider/TriggerProviderWorkerDocsReport`,
      data: {
        ...apiData,
        client_org_ids: JSON.stringify(
          apiData.client_org_ids?.map((item) => item?.organisation_id)
        ),
        provider_org_ids: JSON.stringify(apiData.provider_org_ids),
        worker_ids: JSON.stringify(apiData.worker_ids),
        document_ids: JSON.stringify(apiData.document_ids),
      },
    });

    return response.data;
  } catch (error) {
    return error.message;
  }
};
